import Vue from 'vue'
export default {
    computed: {
        publicState$ () { return this.publicComputed$() }
    },
    methods: {
        publicComputed$ () {
            const mapping = {
                public: { tagContent: 'computedPublicContentFunc$', tagWrapper: 'computedPublicWrapperStyleFunc$', tagChild: 'computedPublicChildStyleFunc$', to: 'publickTo$' },
                student: { tagContent: 'computedNormalContentFunc$', tagWrapper: 'computedNormalWrapperStyleFunc$', tagChild: 'computedNormalChildStyleFunc$', to: 'handleConnectEvent' },
                family: { tagContent: 'computedNormalContentFunc$', tagWrapper: 'computedNormalWrapperStyleFunc$', tagChild: 'computedNormalChildStyleFunc$', to: 'handleConnectEvent' },
                teacher: { tagContent: 'computedNormalContentFunc$', tagWrapper: 'computedNormalWrapperStyleFunc$', tagChild: 'computedNormalChildStyleFunc$', to: 'handleConnectEvent' },
            }
            return mapping[this.currentVersion]
        },
        publickTo$ () {
            window.open('https://www.zeczec.com/projects/kebbiair')
        },
        computedPublicWrapperStyleFunc$ () {
            return this.shit$(`radius:13px;`)
        },
        computedNormalWrapperStyleFunc$ () {
            const computedStyleA = (this.showCloseSocketButton && this.shit$(`bc:rgba(14, 211, 255, 0.6)!; bgc:#272727!;`)) || ''
            const computedStyleB = (this.connectGolbalState && this.shit$(`c:#c8c8c8!; opacity:1!; font-w:500!; box-shadow:none!; bgc:#444444!; font:12px!; bc:#696969!; b:1px; hover:bc:rgba(14, 211, 255, 0.6)!;`)) || ''
            const computedStyleC = this.shit$(`radius:24px; transition:.1s; active:bgc:#272727;`)
            return computedStyleA + computedStyleB + computedStyleC
        },
        computedNormalChildStyleFunc$ () {
            const staticStyle = 'connectGlobalState' + (this.connectGolbalState ? 'Active' : 'Normal')
            const computedStyleA = (!this.connectGolbalState && this.shit$(`c:#00b5e2;`)) || ''
            return staticStyle + computedStyleA
        },
        computedPublicChildStyleFunc$ () {
            return this.shit$(`bgc:#00b5e2; radius:13px; font-w:500; letter-s:1.12px; active:bgc:#272727; active:c:#00b5e2;`)
        },
        computedPublicContentFunc$ () {
            return Vue.prototype.$t("code-lab/component/mixins/publicVersionMix.js_0")
        },
        computedNormalContentFunc$ () {
            return this.connectGolbalState && this.connectDevices.length
            ? this.connectGolbalState === 1 ? `${ Vue.prototype.$t("code-lab/component/mixins/publicVersionMix.js_1") } 「${ this.connectDevices.length }${ Vue.prototype.$t("code-lab/component/mixins/publicVersionMix.js_2") }」 ${ Vue.prototype.$t("code-lab/component/mixins/publicVersionMix.js_3") }` : ''
            : this.connectGolbalState ? this.handleQuickLabel() : Vue.prototype.$t("code-lab/component/mixins/publicVersionMix.js_4")
        }
    }
}
